module.exports = __webpack_public_path__ + "img/Wunderkerzen.bbfcc345.jpg";